export function openWindow(url: string, queryParams: any, useSameWindow = false) {

  const query = new URLSearchParams(queryParams);
  const queryString = query.toString();
  const fullUrl = url + (queryString ? '?' + queryString : '');

  if (useSameWindow) {
    document.location.href = fullUrl;
    return null;
  }

  const w = 770, h = 675;
  const wLeft = window.screenLeft ? window.screenLeft : window.screenX;
  const wTop = window.screenTop ? window.screenTop : window.screenY;
  const left = wLeft + (window.innerWidth / 2) - (w / 2);
  const top = wTop + (window.innerHeight / 2) - (h / 2);

  return window.open(fullUrl, 'songselect-popup', 'resizable,height=' + h + ',width=' + w + ',top=' + top + ',left=' + left);
}